import gql from 'graphql-tag';

export const QUERY_SCHEDULE_REMINDERS = gql`
  query QueryScheduleReminder(
    $filter: ScheduleReminderFilter
    $sort: [ScheduleReminderSort!]
    $first: Int
    $after: String
  ) {
    scheduleReminders(filter: $filter, sort: $sort, first: $first, after: $after) {
      id
      organizationId
      memberId
      startTime
      endTime
      payload
      type
      createdOn
      cursor
      notifyEmployee
      links {
        id
        scheduleReminderId
        memberId
        member {
          id
          firstName
          lastName
          memberGroup {
            id
            groupName
          }
          memberGroupId
          positionId
          position {
            id
            level
            timeEvents
          }
        }
      }
    }
  }
`;

export const QUERY_SCHEDULE_REMINDERS_BASIC_LINKS = gql`
  query ScheduleReminderBasicLinks(
    $filter: ScheduleReminderFilter
    $sort: [ScheduleReminderSort!]
    $first: Int
    $after: String
  ) {
    scheduleReminders(filter: $filter, sort: $sort, first: $first, after: $after) {
      id
      organizationId
      memberId
      startTime
      endTime
      payload
      type
      createdOn
      cursor
      notifyEmployee
      links {
        id
        scheduleReminderId
        memberId
      }
    }
  }
`;
